import React, { Fragment, useState } from 'react';
import { AccessibilityWrapper } from 'legacy-packages/ft-cb';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import { ACTION_DECLINE_SHARE_TITLE } from './SharedAssessmentActions/constants';
import DeclineConfirmationModal from './SharedAssessmentActions/DeclineConfirmationModal';

const DeclineShareAction = ({ handleDeclineShare, assessmentTitle }) => {
  const [showDeclineConfirmationModal, setShowDeclineConfirmationModal] =
    useState(false);
  return (
    <Fragment>
      <AccessibilityWrapper>
        <SingleAction
          iconName="decline"
          onClick={() => setShowDeclineConfirmationModal(true)}
          role="link"
          tabIndex={0}
          iconWidth="16"
          iconHeight="16"
          title={ACTION_DECLINE_SHARE_TITLE}
          ariaLabel={ACTION_DECLINE_SHARE_TITLE}
        >
          <span className="item-text">{ACTION_DECLINE_SHARE_TITLE}</span>
        </SingleAction>
      </AccessibilityWrapper>
      {showDeclineConfirmationModal && (
        <DeclineConfirmationModal
          closeConfirmationModal={() => setShowDeclineConfirmationModal(false)}
          handleDeclineShare={handleDeclineShare}
          title={`Decline ${assessmentTitle}`}
        />
      )}
    </Fragment>
  );
};

export default DeclineShareAction;
